<template>
  <CustomPage title="重设密码">
    <div slot="content" class="content">
      <div class="tip">
        请设置登录密码，需要8-20位字符，必须包含 字母/数字/字符中俩种以上组合
      </div>
      <Form ref="form">
        <Field
          v-model="form.password"
          placeholder="请输入新密码"
          :rules="[{ validator: validPassword, message: '请正确输入新密码' }]"
        />
        <Field
          v-model="form.passwordAgain"
          placeholder="请再次输入新密码"
          :rules="[
            { validator: validPasswordAgain, message: '两次密码输入不一致' },
          ]"
        />
        <div class="btn-box">
          <Button class="btn" @click="nextHandle" :loading="loading"
            >下一步</Button
          >
        </div>
      </Form>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import { mapState } from "vuex";
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import { validPassword } from "@/utils/vaildate";
import { Form, Field, Button, Toast } from "vant";
export default {
  components: { CustomPage, CustomView, Form, Field, Button },
  data() {
    return {
      validPassword,
      loading: false,
      form: {
        password: "",
        passwordAgain: "",
      },
    };
  },
  computed: {
    ...mapState({
      userInfoMobile: (state) => state.user.userInfoMobile,
      code_phone: (state) => state.sms.code_phone,
      code_flag: (state) => state.sms.code_flag,
    }),
  },
  methods: {
    validPasswordAgain(val) {
      if (this.form.password !== val) {
        return false;
      }
      return true;
    },
    nextHandle() {
      this.$refs.form
        .validate()
        .then((res) => {
          if (this.code_phone === this.userInfoMobile && this.code_flag) {
            this.$router.push({
              name: "SettingSafePwdCode",
              query: {
                type: "reset_password",
                phone: this.userInfoMobile,
                newPassword: this.form.password,
              },
            });
          } else {
            this.loading = true;
            this.$store
              .dispatch("sms/changePasswordSendCode", this.userInfoMobile)
              .then((res) => {
                Toast.success("已发送验证码");
                this.loading = false;
                this.$router.push({
                  name: "SettingSafePwdCode",
                  query: {
                    type: "reset_password",
                    phone: this.userInfoMobile,
                    newPassword: this.form.password,
                  },
                });
              })
              .catch(() => {
                this.loading = false;
              });
          }
        })
        .catch((err) => {
          Notify("信息填写有误");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.tip {
  padding: 42px 40px 10px;
  font-size: 32px;
  line-height: 40px;
  color: #808080;
}
.btn-box {
  padding: 80px 40px 0;
}
.btn {
  width: 100%;
  background: #e82035;
  line-height: 82px;
  border-radius: 50px;
  font-size: 26px;
  text-align: center;
  color: #fff;
}
.van-form {
  .van-cell {
    font-size: 28px;
    line-height: 1em;
    padding: 28px 40px;
    /deep/ .van-field__label {
      color: #333333;
    }
    &::after {
      border-color: #aeaeae;
    }
  }
  .van-cell:last-child::after {
    display: block;
  }
}
</style>
